import { CONVERSATIONS_API_URL } from 'constants/ApiConstants';
import * as types from 'modules/chat/actionTypes';

/**
 * @param {{ ids?: string[], conversationId?: string, additionalConversationId?: string } & Record<string, unknown>} payload
 * @param {Object} [meta={}]
 * @returns {import("../types").FetchConversationAttachmentsAction}
 */
export const fetchConversationAttachments = ({ ids, conversationId, additionalConversationId, ...params }, meta = {}) => {
  const resolvedIds = ids ?? [conversationId, additionalConversationId].filter(Boolean);
  return {
    type: types.FETCH_CONVERSATION_ATTACHMENTS,
    payload: {
      request: {
        method: 'GET',
        url: `${CONVERSATIONS_API_URL}/messages/medias`,
        params: {
          page: 0,
          size: 20,
          sort: 'createdOn,desc',
          conversationIds: resolvedIds.join(','),
          ...params,
        },
      },
    },
    meta,
  };
};

/**
 * @param {unknown} attachments
 * @param {Object} [meta={}]
 * @returns {import("../types").FetchConversationAttachmentsSuccessAction}
 */
export const fetchConversationAttachmentsSuccess = (attachments, meta = {}) => ({
  type: types.FETCH_CONVERSATION_ATTACHMENTS_SUCCESS,
  payload: attachments,
  meta,
});

/**
 * @param {Object} [meta={}]
 * @returns {import("../types").UnmountConversationAttachmentsPaneAction}
 */
export const unmountConversationAttachmentsPane = (meta = {}) => ({
  type: types.UNMOUNT_CONVERSATION_ATTACHMENTS_PANE,
  meta,
});
